module.exports = __webpack_public_path__ + "img/EncabezadoControlParts.778f91ee.png";